import { useState, useEffect } from "react"
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import CboGrupo from "./CboGrupo";
import CboEmpresa from "./CboEmpresa";
import CboSeccion from "./CboSeccion";
import CboCurso from "./CboCurso";
import CboDivision from "./CboDivision";

const RepoAlumnos = (props) => {


  const [codigo, setCodigo] = useState("")
  const [nombre, setNombre] = useState("")
  const [grupo, setGrupo] = useState(1)
  const [empresa, setEmpresa] = useState("")
  const [seccion, setSeccion] = useState("")
  const [curso, setCurso] = useState("")
  const [division, setDivision] = useState("");
  const [noteditable, setNoteditable] = useState(false);
  const [repoHtml, setRepoHtml] = useState("");

  const [pdfUrl, setPdfUrl] = useState(null);

  const [activo, setActivo] = useState(false)

  // ventana de búsqueda
  const [vermodal, setVermodal] = useState(false)


  // ventana de confirmación
  const [vermodalconf, setVermodalConf] = useState(false)

  // toast
  const [showToast, setShowToast] = useState(false);
  const [textoToast, setTextoToast] = useState("");

  /*
     async function    handleOnChangeActivo(e){
      setSearchActivo(!searchactivo); 
      setSearchMessage("");
   }
   
  */

  //manejo del filtrar  ( carga del pedido)
  const [loading, setLoading] = useState(false);


  useEffect(() => {

    /*    var json3;
        var jsons3;
       var url3;
      let consulta = new Object();
    
      setGrupo(props.grupo); 
      consulta.grupo = props.grupo;
      consulta.empresa = 1;
      
      jsons3 = JSON.stringify(consulta);
  
  
      var options3 = {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json'
  
      },
      mode: 'cors',
      credential : 'include',
      body:  jsons3,
      
      };
  
      url3 = `${process.env.REACT_APP_API_URL}/sec/allsecciones`;
          
          
                     
                  fetch(url3, options3)
                  .then( response => response.json())
                  .then( data => {
                  
                  json3 = data.data;
                  setSecciones(json3);
                  // si hay datos, cargar en la ficha el primero
                  if (json3.length)
                  {
                      console.log("si", json3, json3[0].Sec_Nombre);
                      setNombre(json3[0].Sec_Nombre);
                  }
                  console.log("Secciones", json3);
                     
                  })
      
  */
  }, []);




  const handleGrupoChange = (event) => {
    console.log("cambio grupo..", event);
    setGrupo(event.target.value);
  };

  const handleEmpresaChange = (event) => {
    setEmpresa(event.target.value);
  };

  const handleSeccionChange = (event) => {
    setSeccion(event.target.value);
  };

  const handleCursoChange = (event) => {
    console.log("cbio curso", event.target.value);
    setCurso(event.target.value);
    if (event.target.value == 0) {
      setDivision("")
    }
  };

  const handleDivisionChange = (event) => {
    setDivision(event.target.value);
  };


  const handlePDF = async (event) => {

    var jsons3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.empresa = empresa;
    consulta.seccion = seccion;
    consulta.curso = curso;
    consulta.division = division;
    consulta.format = 'pdf';
    jsons3 = JSON.stringify(consulta);
    const response = await fetch(`${process.env.REACT_APP_API_URL}/repo/listalu`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: jsons3
    });

    const blob = await response.blob();
    if (blob.size > 2) {
      // 2. Creamos una URL temporal para ese archivo binario
      const url = window.URL.createObjectURL(blob);

      // 3. Abrimos esa URL en una pestaña nueva
      // El navegador usará su visor de PDF nativo
      window.open(url, '_blank');
    }
    else {
      console.log("Manjear error, no hay PDF (ni datos)");
    }

  };


  const handleList = async () => {

    setLoading(true);

    try {

      let consulta = new Object();
      var jsons3;
      consulta.grupo = grupo;
      consulta.empresa = empresa;
      consulta.seccion = seccion;
      consulta.curso = curso;
      consulta.division = division;
      consulta.format = 'html';
      //consulta.grusu = grusu;

      jsons3 = JSON.stringify(consulta);


      var options3 = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        mode: 'cors',
        credential: 'include',
        body: jsons3,

      };


      const res = await fetch(`${process.env.REACT_APP_API_URL}/repo/listalu`, options3);
      console.log("repo-1");

      //const { html, pdfBase64 } 
      const resu = await res.json();
      console.log("repo-2");

      // 1. Mostrar el HTML (ej: en un estado para un modal)
      setRepoHtml(resu.html);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };

  return (

    <div >

      <form >

        <div className="uno">
          <CboGrupo className="botones"
            selectedValue={grupo}
            onChange={handleGrupoChange}
            disabled={noteditable}
            grusu={props.grusu}
          />

          <CboEmpresa className="botones"
            selectedValue={empresa}
            onChange={handleEmpresaChange}
            disabled={noteditable}
            grupo={grupo}
            grusu={props.grusu}
          />
          <CboSeccion className="botones"
            selectedValue={seccion}
            onChange={handleSeccionChange}
            disabled={noteditable}
            grupo={grupo}
            empresa={empresa}
            grusu={props.grusu}
          />
          <CboCurso className="botones"
            selectedValue={curso}
            onChange={handleCursoChange}
            disabled={noteditable}
            grupo={grupo}
            empresa={empresa}
            seccion={seccion}
          />
          <CboDivision className="botones"
            selectedValue={division}
            onChange={handleDivisionChange}
            disabled={noteditable || curso == 0}
            grupo={grupo}
            empresa={empresa}
            seccion={seccion}
          />
          <div className="acciones-filtros">
            <button
              type="button"
              className="filtrar"
              id="clear"
              onClick={handleList}
              disabled={loading}
            >
              {
                loading
                  ?
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Procesando...
                  </>
                  :
                  <>
                    <i className="fa-solid fa-magnifying-glass me-2"></i>
                    Listar
                  </>
              }

            </button>

            <button
              type="button"
              className="filtrar"
              id="edit"
              onClick={handlePDF}
            >
              PDF
            </button>
          </div>
        </div>
      </form>



      <div className="contenedor-reporte">
        <div dangerouslySetInnerHTML={{ __html: repoHtml }} />
      </div>

      <ToastContainer position="bottom-end">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Body>{textoToast}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <div
          id="liveToastmsg"
          className="toast"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="toast-body"></div>
        </div>
      </div>

    </div>
  );
};

export default RepoAlumnos;

